export const splitArray = <T>(array: T[], perChunk: number): T[][] => {
  const result = array.reduce((resultArray: T[][], item, index) => {
    const chunkIndex = Math.floor(index / perChunk)

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []
    }

    resultArray[chunkIndex].push(item)

    return resultArray
  }, [] as T[][])

  return result
}
